import React from 'react'
import { Typography, Box } from '@mui/material'
import SubscribeToView from 'components/Common/SubscribeToView'
// import { useSelector } from 'react-redux'

const FreeUser = ({ data }) => {
  return (
    <>
      <Typography className="py-1" variant="body2">
        Public Company:&nbsp;
        <SubscribeToView />
      </Typography>
      <Typography className="py-1" variant="body2">
        Estimated Annual Revenue (This Location):&nbsp;
        <SubscribeToView />
      </Typography>
      <Typography className="py-1" variant="body2">
        Estimated Annual Revenue (Corporate):&nbsp;
        <SubscribeToView />
      </Typography>
    </>
  )
}

const FinancialComponent = ({ data, isFreeAccount, isEditable }) => {
  const { details } = data
  // const { business_info } = useSelector(state => state.apiResponseReducers.dashboardInfo)

  const showClaimed = !isFreeAccount || isEditable

  const formatRevenue = number => {
    return parseInt(`${number}`).toLocaleString('en-US')
  }

  return (
    <Box display={'flex'} gap="7px" alignItems="baseline">
      <Box display="flex" flexDirection="column">
        {showClaimed ? (
          <>
            {details.publicCompany && (
              <Typography className="py-1" variant="body2">
                Public Company: {details.publicCompany === 'Y' ? 'Yes' : 'No'}
              </Typography>
            )}
            {details.estimatedAnnualRevenueLocal ? (
              <Typography className="py-1" variant="body2">
                Estimated Annual Revenue (Corporate):&nbsp;
                {`$${formatRevenue(details.estimatedAnnualRevenueCorp)}`}
              </Typography>
            ) : null}
          </>
        ) : (
          <FreeUser data={data} />
        )}
      </Box>
    </Box>
  )
}

export default FinancialComponent
